import { render, staticRenderFns } from "./BaseSettingWidget.vue?vue&type=template&id=96052a32&scoped=true&"
import script from "./BaseSettingWidget.vue?vue&type=script&lang=js&"
export * from "./BaseSettingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96052a32",
  null
  
)

export default component.exports